import { Megaphone } from "lucide-react";
import { useActiveAnnouncement } from "../use-active-announcement";

// Port of /components/portal/AnnouncementStrip.tsx. The legacy server
// component fetched directly from Supabase and rode RLS for audience scoping;
// the SPA consumes the same data via the Hono /portal/announcements/active
// route, which replicates the tier + partner_type scope checks server-side.
//
// Renders nothing when there's no matching active announcement (or while the
// query is loading) — a flashing strip is more disruptive than a delayed one.
export function AnnouncementStrip() {
  const { data } = useActiveAnnouncement();
  if (!data) return null;

  return (
    <div className="mb-6 flex items-start gap-3 rounded-xl border border-accent/30 bg-accent/5 px-4 py-3">
      <Megaphone className="mt-0.5 h-4 w-4 shrink-0 text-accent" />
      <p className="text-sm text-foreground">{data.body}</p>
    </div>
  );
}
